//components
import { Button as BaseButton } from '@mui/material';

//css
import styled from 'styled-components';

const eventTypeOptions = {
  Create: 'Add Event Type',
};

const Options = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 2%;
  margin-bottom: 2%;
`;

const Button = styled(BaseButton)`
  &&& {
    margin-right: 2%;
  }
`;

export const GenerateEventTypeOptions = props => {
  const { handleClick } = props;
  return (
    <Options>
      {Object.keys(eventTypeOptions).map(item => {
        return (
          <Button key={item} id={item} variant='contained' onClick={handleClick}>
            {eventTypeOptions[item]}
          </Button>
        );
      })}
    </Options>
  );
};
